import { render, staticRenderFns } from "./goodsAttention.vue?vue&type=template&id=7ba01dbc&scoped=true"
import script from "./goodsAttention.vue?vue&type=script&lang=js"
export * from "./goodsAttention.vue?vue&type=script&lang=js"
import style0 from "./goodsAttention.vue?vue&type=style&index=0&id=7ba01dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba01dbc",
  null
  
)

export default component.exports